import * as React from "react";
import Booth, {BoothPaymentMethods, BoothTerms} from "../../_data/models/Booth";
import BreadcrumbsComponent from "../../_widgets/breadcrumbs/BreadcrumbsComponent";
import {ShopsRoutes} from "../../routes";
import Shop from "../../_data/models/Shop";
import {Link} from "react-router-dom";
import {Redirect} from "react-router";
import { Field, reduxForm } from 'redux-form';
import * as _ from "lodash";
import InputComponent from "../../_widgets/form/InputComponent";
import {positive_number} from "../../_widgets/form/validators";

interface Props {
    booth: Booth;
    shop: Shop;
    handleSubmit: any;
    onSubmit: (booth: Booth) => void,
    initialValues: Booth;
    submitting: boolean;
}

function termOptions() {
    return _.map(BoothTerms, (each) => {
        return (
            <option key={each} value={each}>{each}</option>
        )
    })
}

const BoothForm = (props: Props) => {

    const {booth, shop, handleSubmit, onSubmit, submitting} = props;
    if (!booth || !shop) {
        return <Redirect to={{pathname: ShopsRoutes.index(), state: {refresh: true}}}/>
    }
    const pageTitle =  booth.isNew() ? "New Booth for Rent" : booth.toString();

    return (
        <div>
            <div className="row expanded">
                <BreadcrumbsComponent>
                    <li>
                        <Link to={ShopsRoutes.index()}>Shops</Link>
                    </li>
                    <li>
                        <Link to={ShopsRoutes.view(shop.id)}>{shop.name}</Link>
                    </li>

                    <li>{pageTitle}</li>
                </BreadcrumbsComponent>

            </div>

            <div className="row expanded">
                <div className="large-12 columns">
                    <div className="text-group mt-1 mb-1">
                        <h4>{pageTitle}</h4>

                        <p className="subheader">{shop.toString()}</p>
                    </div>
                </div>
            </div>

            <div className="row expanded">
                <div className="large-12 columns">
                    <div className="callout">

                        <form onSubmit={handleSubmit(onSubmit)}>

                            <Field name="price"  label="Rent Amount ($)" component={InputComponent} type="number" validate={[positive_number]}/>

                            <Field name="workstationCount"  label="Booths Available" required component={InputComponent} type="number" validate={[positive_number]}/>

                            <div className="row">
                                <div className="medium-6 columns">
                                    <label>Rate
                                        <span className="red label-text">*</span>
                                        <Field name="terms" component="select">
                                            {termOptions()}
                                        </Field>
                                    </label>
                                </div>
                            </div>

                            <div className="row">
                                <div className="medium-6 columns">
                                    <legend>Payment Method</legend>
                                    <fieldset>
                                        <div>
                                            <Field name="isNegotiable" component="input" type="checkbox" /> {BoothPaymentMethods.NEGOTIABLE}
                                        </div>
                                        <div >
                                            <Field name="isCommissioned" component="input" type="checkbox" /> {BoothPaymentMethods.COMMISSION}
                                        </div>

                                    </fieldset>
                                </div>
                            </div>

                            <div className="row">
                                <div className="medium-6 columns">
                                    <div className="mt-1">
                                        <button type="submit" disabled={submitting} className="button success">Save Changes</button>
                                        <Link className="button link" to={ShopsRoutes.view(shop.id)}>Cancel</Link>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>
    );
};

const BoothFormComponent = reduxForm({
    form: 'profile_form'
})(BoothForm);

export default BoothFormComponent;


// WEBPACK FOOTER //
// ./app/client/booth/components/BoothFormComponent.tsx